export default __webpack_public_path__ + "exp-icon4239254.png";